import React from "react";

// Slow editorial marquee. Duplicated content for seamless loop.
export default function Marquee({ items, className = "" }) {
  const row = (
    <div className="flex shrink-0 items-center gap-16 pr-16" aria-hidden="true">
      {items.map((t, i) => (
        <span key={i} className="flex items-center gap-16">
          <span className="font-display italic text-4xl sm:text-6xl text-av-white/90">{t}</span>
          <span className="text-av-bright text-4xl sm:text-6xl">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <div className={`relative flex overflow-hidden select-none ${className}`} role="presentation">
      <div className="flex animate-marquee whitespace-nowrap motion-reduce:animate-none">
        {row}
        {row}
      </div>
    </div>
  );
}
